import { useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App";
import { authStore } from "entities/Auth";
import {
  createRoadSearchQueryParams,
  RoadQueryParams,
  roadSearchCardStore,
  RoadSearchRequestFunc,
} from "entities/RoadSearchCard";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { RequiredBy } from "shared/lib/typeCheck.lib";

import { getInitialSearchQPM } from "../ParamsManager";

type UseUrlQueryBasedInitialSearchProps = {
  searchController: {
    searchRequest: RoadSearchRequestFunc;
    // getCards: GetRoadCardsFunc;
    isSearchLoading: boolean;
  };
  openedCardAction: (card: ShipmentModel | null) => { type: string; payload: ShipmentModel | null };
};

type UseRoadUrlQueryBasedInitialSearchReturnType = {
  roadInitialSearch: ({ requestedFromUrl }: { requestedFromUrl: boolean }) => void;
};

export const useRoadUrlQueryBasedInitialSearch = ({
  searchController,
  openedCardAction,
}: UseUrlQueryBasedInitialSearchProps): UseRoadUrlQueryBasedInitialSearchReturnType => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const { showOpenedCardView } = usePanelViews();
  const { searchRequest, isSearchLoading } = searchController;
  const initialSearchQPM = useRef(getInitialSearchQPM()).current;

  const createRequestFuncByStrategy = (
    strategy: "authenticated" | "not-authenticated",
    requestParams: RequiredBy<RoadQueryParams, "number" | "carrier" | "type">
  ): (() => void) | null => {
    const reqParams = createRoadSearchQueryParams({
      requestType: "search",
      override: requestParams,
    });
    if (!reqParams) return null;

    switch (strategy) {
      case "authenticated":
        return () => {
          // getCards(
          //   { where: { reference: requestParams.number } },
          //   {
          //     onSettled: (userTrackingResponse) => {
          //       searchRequest(reqParams, {
          //         onSuccess: (trackingResponse) => {
          //           if (trackingResponse.rawDataParser.requestLimitReached) return;
          //           dispatch(setOpenedCardAction(trackingResponse));
          //         },
          //         onSettled: (trackingResponse) => {
          //           if (userTrackingResponse?.length) {
          //             dispatch(prependSavedCardAction({ data: userTrackingResponse[0] }));
          //             return;
          //           }
          //           if (trackingResponse && !trackingResponse?.rawDataParser.requestLimitReached) {
          //             dispatch(prependTrackingCardAction({ data: trackingResponse }));
          //           }
          //         },
          //       });
          //     },
          //   }
          // );
          searchRequest(reqParams, {
            onSuccess: (trackingResponse) => {
              if (trackingResponse.requestLimitReached) return;
              dispatch(openedCardAction(trackingResponse));
            },
            onSettled: (trackingResponse) => {
              //   if (userTrackingResponse?.length) {
              //     dispatch(prependSavedCardAction({ data: userTrackingResponse[0] }));
              //     return;
              //   }
              if (trackingResponse && !trackingResponse?.requestLimitReached) {
                dispatch(roadSearchCardStore.actions.prependSearchCardAction({ data: trackingResponse }));
              }
            },
          });
        };
      case "not-authenticated":
      default:
        return () => {
          searchRequest(reqParams, {
            onSuccess: (trackingResponse) => {
              dispatch(roadSearchCardStore.actions.prependSearchCardAction({ data: trackingResponse }));
              dispatch(openedCardAction(trackingResponse));
            },
          });
        };
    }
  };

  const roadInitialSearch = ({ requestedFromUrl }: { requestedFromUrl: boolean }) => {
    if (!requestedFromUrl || isSearchLoading) return;

    const roadReferenceQueryValue = initialSearchQPM.get("number") ?? initialSearchQPM.get("container");

    const roadCarrierQueryValue = initialSearchQPM.get("carrier");

    const roadTypeQueryValue = initialSearchQPM.get("type");

    if (!roadReferenceQueryValue) return;

    dispatch(appStore.actions.setRequestedFromUrl(true));

    showOpenedCardView();

    const requestFunc = createRequestFuncByStrategy(isAuthenticated ? "authenticated" : "not-authenticated", {
      number: roadReferenceQueryValue,
      carrier: roadCarrierQueryValue,
      type: roadTypeQueryValue,
    });

    requestFunc?.();
  };

  return { roadInitialSearch };
};
